// extracted by mini-css-extract-plugin
export var container = "_8j-0";
export var containerTopRight = "_8j-1";